// Request queue utility
export const PRIORITY = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low'
};

export function queueRequest(request, priority = PRIORITY.MEDIUM) {
  // Simple queue implementation - can be enhanced later
  // Call the request function to get the actual promise
  if (typeof request !== 'function') {
    return Promise.reject(new Error('queueRequest: request must be a function'));
  }
  try {
    const promise = request();
    if (!promise || typeof promise.then !== 'function') {
      return Promise.reject(new Error('queueRequest: request function must return a promise'));
    }
    return promise;
  } catch (error) {
    return Promise.reject(error);
  }
}

export function getPriorityFromEndpoint(endpoint) {
  // Determine priority based on endpoint
  if (endpoint.includes('/health') || endpoint.includes('/ping')) {
    return PRIORITY.LOW;
  }
  if (endpoint.includes('/critical') || endpoint.includes('/auth')) {
    return PRIORITY.HIGH;
  }
  return PRIORITY.MEDIUM;
}
